import { api, request } from "../common";
import {
  GET_LICENSE_STATUS,
  GET_LICENSE_TOKEN,
  GET_LICENSE,
  POST_LICENSE_ACTIVATE,
} from "../constants";
import {
  ActivateLicense,
  ActivateLicenseRequest,
  ActivateLicenseResponse,
} from "./type";

export const licenseApi = api.injectEndpoints({
  endpoints: builder => ({
    activateLicense: builder.mutation<
      ActivateLicenseResponse,
      ActivateLicenseRequest
    >({
      query: ({ license }) => {
        return {
          data: { license },
          method: "POST",
          url: POST_LICENSE_ACTIVATE,
          withCredentials: true,
        };
      },
    }),
    getLicense: builder.query<ActivateLicense, any>({
      query: () => {
        return {
          method: "GET",
          params: {}, // no parameters
          url: GET_LICENSE,
          withCredentials: true,
        };
      },
    }),
    getStatus: builder.query<any, void>({
      query: () => {
        return {
          method: "GET",
          params: {}, // no parameters
          url: GET_LICENSE_STATUS,
          withCredentials: true,
        };
      },
    }),
    getToken: builder.query<{ data: string }, any>({
      query: () => {
        return {
          method: "GET",
          params: {}, // no parameters
          url: GET_LICENSE_TOKEN,
          withCredentials: true,
        };
      },
    }),
  }),
});

export const {
  useActivateLicenseMutation,
  useGetLicenseQuery,
  useGetStatusQuery,
  useGetTokenQuery,
  useLazyGetStatusQuery,
} = licenseApi;
